import { useState } from 'react';
import {} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog, SttList } from '../../../sporttia/all';
import BookingDialog from '../../../components/dialogs/bookingDialog/BookingDialog';

export default function TimetableBookingsDialog({
    open = false,
    bookings,
    onClose,
    cutBooking = null,
}: any) {
    const { t } = useTranslation();
    const [openBookingId, setOpenBookingId] = useState<number | undefined>(
        undefined,
    );

    // -----| Render |-----
    return (
        <>
            <SttDialog
                title={t('booking.bookings')}
                open={open}
                onClose={onClose}
                content={
                    <SttList
                        paper
                        numRows={10}
                        onSelect={(booking: any) =>
                            setOpenBookingId(booking.id)
                        }
                        data={bookings.map((booking: any) => ({
                            caption: `${booking.name} [ ${booking.numOccupants} ]`,
                            objToSelect: booking,
                        }))}
                    />
                }
                buttons={[
                    {
                        type: 'close',
                        onClick: onClose,
                    },
                ]}
            />

            {/* --- Booking dialog --- */}
            {openBookingId !== undefined && (
                <BookingDialog
                    idBooking={openBookingId}
                    onClose={() => setOpenBookingId(undefined)}
                    onUpdate={() => {
                        onClose();
                    }}
                    cutBooking={cutBooking}
                />
            )}
        </>
    );
}
